import React, { ReactNode } from 'react';

import { IViewFieldBaseProps, ViewFieldBase } from './ViewFieldBase';

export type {
  IViewFieldBaseProps,
  ViewFieldLabelVariant,
} from './ViewFieldBase';
export { ViewFieldBase } from './ViewFieldBase';

export default function ViewField(props: IViewFieldBaseProps) {
  return <ViewFieldBase {...props} />;
}

export function ViewFieldH2(props: IViewFieldBaseProps) {
  return <ViewFieldBase {...props} valueVariant="h2" />;
}

export function ViewFieldH1(props: IViewFieldBaseProps) {
  return <ViewFieldBase {...props} valueVariant="h1" />;
}

export function ViewFieldLabelPrimaryH1(props: IViewFieldBaseProps) {
  return <ViewFieldBase {...props} labelVariant="primary" valueVariant="h1" />;
}
